import React, { Component } from 'react';
import { Breadcrumb, DatePicker, Button, message, Divider, Modal } from 'antd';
import moment from 'moment';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import { localStorageClient } from '../../../../utils/localStorageClient';
import CptGrid from './CptGrid';
import AddOrEditCptModalDialog from './AddOrEditCptModalDialog';
import DelCptModalDialog from './DelCptModalDialog';
import OperationRecordDialog from '../../common/historyUpload/operationRcd/components/OperationRecordDialog';
import './CptDashboard.css';

class CptDashboard extends Component {
  state = {
    yearPickerMode: 'year',
  };

  componentDidMount() {
    this.refreshBtnOnClicked();
  }

  componentDidUpdate() {
    const {
      loadCptInfoActionStatus,
      loadCptInfoResp,
      submitCptActionStatus,
      submitCptRespErrMsg,
    } = this.props;

    if (loadCptInfoActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadCptInfoActionStatus();
    }
    if (loadCptInfoActionStatus === ACTION_STATUS.ERROR) {
      let err = 'Load CPT records failed';
      if (loadCptInfoResp && loadCptInfoResp.respMessage) {
        err = loadCptInfoResp.respMessage;
      }
      message.error(err);
      this.props.initLoadCptInfoActionStatus();
    }

    if (submitCptActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Submit CPT succeeded');
      this.props.initSubmitCptActionStatus();
      this.refreshBtnOnClicked();
    }
    if (submitCptActionStatus === ACTION_STATUS.ERROR) {
      message.error(submitCptRespErrMsg || 'Submit CPT failed');
      this.props.initSubmitCptActionStatus();
    }
  }

  onInputChange = ({ name, value }) => {
    this.props.onCptQueryInputChange({ name, value });
  };

  onYearChange = (date, dateString) => {
    this.onInputChange({ name: 'year', value: date ? dateString : '' });
  };

  onYearPanelChange = value => {
    this.setState({ yearPickerMode: 'year' });
    this.onInputChange({ name: 'year', value: value ? value.format('YYYY') : '' });
  };

  onYearOpenChange = open => {
    if (!open) {
      this.setState({ yearPickerMode: 'year' });
    }
  };

  refreshBtnOnClicked = () => {
    const { year } = this.props.cptQueryFields;
    this.props.loadCptInfo({ employee: localStorageClient.getUserName(), year });
  };

  getSingleSelectedRecord = () => {
    const { selectedCptInfoArray } = this.props;
    if (selectedCptInfoArray.length !== 1) {
      message.warning('Please choose one and only one CPT record');
      return null;
    }
    return selectedCptInfoArray[0];
  };

  addOrEditBtnOnClicked = mode => {
    if (mode === 'ADD') {
      this.props.openAddOrEditCptModal(mode, null);
      return;
    }
    const currentRecord = this.getSingleSelectedRecord();
    if (!currentRecord) {
      return;
    }
    if (mode === 'EDIT' && ['PendingApproval', 'Approved'].includes(currentRecord.complianceApproval)) {
      message.warning('Only draft or rejected CPT records can be edited');
      return;
    }
    this.props.openAddOrEditCptModal(mode, currentRecord);
  };

  delBtnOnClicked = () => {
    const currentRecord = this.getSingleSelectedRecord();
    if (!currentRecord) {
      return;
    }
    if (currentRecord.complianceApproval === 'Approved') {
      message.warning('Approved CPT records cannot be deleted');
      return;
    }
    this.props.openDelCptModal(currentRecord);
  };

  submitBtnOnClicked = () => {
    const currentRecord = this.getSingleSelectedRecord();
    if (!currentRecord) {
      return;
    }
    if (['PendingApproval', 'Approved'].includes(currentRecord.complianceApproval)) {
      message.warning('Only draft or rejected CPT records can be submitted');
      return;
    }

    Modal.confirm({
      title: 'Submit this CPT record?',
      onOk: () => {
        this.props.submitCpt({
          id: currentRecord.id,
          employee: currentRecord.employee || localStorageClient.getUserName(),
          eventDate: currentRecord.eventDate,
          eventOrganizer: currentRecord.eventOrganizer,
          eventName: currentRecord.eventName,
          cptCategory: currentRecord.cptCategory,
          cptHours: currentRecord.cptHours,
          attachment: currentRecord.attachment,
          attachmentOriginName: currentRecord.attachmentOriginName,
          remarks: currentRecord.remarks,
          complianceApproval: 'PendingApproval',
          mode: 'EDIT',
          source: 'Report',
        });
      },
    });
  };

  operationRcdBtnOnClicked = () => {
    const { selectedCptInfoArray, cptOperationRecordUrl, loadCptInfoResp } = this.props;
    const queryFields = {
      module: 'CPT',
      queryUrl: cptOperationRecordUrl,
    };
    if (selectedCptInfoArray && selectedCptInfoArray.length > 0) {
      queryFields.dataId = selectedCptInfoArray.map(item => item.id).join(',');
    } else {
      const allRows = loadCptInfoResp && Array.isArray(loadCptInfoResp.data)
        ? loadCptInfoResp.data
        : [];
      if (allRows.length > 0) {
        queryFields.dataId = allRows.map(item => item.id).join(',');
      } else {
        queryFields.dataId = '-1';
      }
    }
    this.props.doOperationRecordAction({
      action: 'OPEN_AND_QUERY',
      queryFields,
      customColumns: ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'],
    });
  };

  render() {
    const { cptQueryFields, loadCptInfoActionStatus, submitCptActionStatus } = this.props;
    const { year } = cptQueryFields;
    const isLoading = loadCptInfoActionStatus === ACTION_STATUS.LOGINING || submitCptActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div className="CptWrapper">
        <div className="breadcrumbWrapper">
          <Breadcrumb>
            <Breadcrumb.Item>Licensing</Breadcrumb.Item>
            <Breadcrumb.Item>CPT</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="CptOperationBar">
          <DatePicker
            allowClear
            size="small"
            mode={this.state.yearPickerMode}
            value={year ? moment(year, 'YYYY') : null}
            format="YYYY"
            style={{ width: 120, marginLeft: 10 }}
            placeholder="Year"
            onChange={this.onYearChange}
            onPanelChange={this.onYearPanelChange}
            onOpenChange={this.onYearOpenChange}
          />
          <Button
            onClick={this.refreshBtnOnClicked}
            loading={isLoading}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
            icon="search"
          />

          <Divider type="vertical" />

          <Button
            onClick={() => this.addOrEditBtnOnClicked('ADD')}
            size="small"
            className="positive-button"
          >
            Add
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked('COPY')}
            size="small"
            style={{ marginLeft: 10 }}
            className="positive-button"
          >
            Copy
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked('EDIT')}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Edit
          </Button>
          <Button
            onClick={this.delBtnOnClicked}
            size="small"
            style={{ marginLeft: 10 }}
            className="negative-button"
          >
            Del
          </Button>
          <Button
            onClick={this.submitBtnOnClicked}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Submit
          </Button>

          <Divider type="vertical" />

          <Button
            onClick={this.operationRcdBtnOnClicked}
            size="small"
            type="primary"
          >
            Operation Record
          </Button>
        </div>

        <div className="CptGrid"><CptGrid {...this.props} /></div>
        <AddOrEditCptModalDialog {...this.props} />
        <DelCptModalDialog {...this.props} />
        <OperationRecordDialog {...this.props} />
      </div>
    );
  }
}

export default CptDashboard;
